<template>
  <header class="main-header">
    <div class="header-inner">
      <div class="header-left">
        <router-link to="/floricultura" class="logo-link">
          <img
            v-if="$route.path !== '/floricultura'"
            src="../assets/Logo-Memorial-Parque-M.svg"
            alt="Memorial Parque Maceió"
            class="logo-img"
          />
          <img
            v-else
            src="../assets/memorial-flores.png"
            alt="Memorial Flores"
            class="logo-img-flores"
          />
        </router-link>
      </div>
      <nav class="header-nav">
        <router-link
          to="/floricultura"
          class="nav-link"
          :class="{ active: $route.path === '/floricultura' || $route.path === '/' }"
          >Floricultura</router-link
        >
        <router-link
          to="/acompanhar-pedido"
          class="nav-link"
          :class="{ active: $route.path === '/acompanhar-pedido' }"
          >Acompanhar Pedido</router-link
        >
        <router-link
          to="/login"
          class="nav-link"
          :class="{ active: $route.path === '/login' }"
          >Área Restrita</router-link
        >
      </nav>
      <div class="header-right">
        <router-link
          to="/carrinho"
          class="cart-link"
          title="Carrinho de Compras"
        >
          <svg
            class="cart-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V17C17 18.1 17.9 19 19 19C20.1 19 21 18.1 21 17V13M9 19.5C9.8 19.5 10.5 20.2 10.5 21C10.5 21.8 9.8 22.5 9 22.5C8.2 22.5 7.5 21.8 7.5 21C7.5 20.2 8.2 19.5 9 19.5ZM20 19.5C20.8 19.5 21.5 20.2 21.5 21C21.5 21.8 20.8 22.5 20 22.5C19.2 22.5 18.5 21.8 18.5 21C18.5 20.2 19.2 19.5 20 19.5Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span v-if="totalItens > 0" class="cart-badge">{{ totalItens }}</span>
        </router-link>
        <a
          href="https://api.whatsapp.com/send?phone=5582991229510"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-fale-conosco"
          >Fale Conosco</a
        >
      </div>
      <button
        type="button"
        class="btn-menu-mobile"
        :class="{ active: menuAberto }"
        @click="menuAberto = !menuAberto"
        aria-label="Menu"
      >
        <span class="hamburger"></span>
        <span class="hamburger"></span>
        <span class="hamburger"></span>
      </button>
    </div>
    <div
      class="header-mobile-overlay"
      :class="{ ativo: menuAberto }"
      @click="menuAberto = false"
    >
      <nav class="header-mobile-nav">
        <router-link
          to="/floricultura"
          class="nav-link"
          :class="{ active: $route.path === '/floricultura' || $route.path === '/' }"
          @click.native="menuAberto = false"
          >Floricultura</router-link
        >
        <router-link
          to="/acompanhar-pedido"
          class="nav-link"
          :class="{ active: $route.path === '/acompanhar-pedido' }"
          @click.native="menuAberto = false"
          >Acompanhar Pedido</router-link
        >
        <router-link
          to="/login"
          class="nav-link"
          :class="{ active: $route.path === '/login' }"
          @click.native="menuAberto = false"
          >Área Restrita</router-link
        >
        <router-link
          to="/carrinho"
          class="nav-link"
          @click.native="menuAberto = false"
          >Carrinho</router-link
        >
        <a
          href="https://api.whatsapp.com/send?phone=5582991229510"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-fale-conosco"
          @click="menuAberto = false"
          >Fale Conosco</a
        >
      </nav>
    </div>
  </header>
</template>

<script>
import carrinhoStore from "../store/carrinho";

export default {
  name: "Header",
  data() {
    return {
      totalItens: 0,
      menuAberto: false,
    };
  },
  watch: {
    $route() {
      this.atualizarTotalItens();
      this.menuAberto = false;
    },
    menuAberto(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  mounted() {
    this.atualizarTotalItens();
    // Atualizar periodicamente para refletir mudanças no localStorage
    this.intervalId = setInterval(() => {
      this.atualizarTotalItens();
    }, 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    document.body.style.overflow = "";
  },
  methods: {
    atualizarTotalItens() {
      this.totalItens = carrinhoStore.getTotalItens();
    },
  },
};
</script>

<style scoped>
/* Header: padrão footerenav + itens atuais */
.main-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 100;
  font-family: "DM Sans", -apple-system, sans-serif;
}

.header-inner {
  max-width: 1320px;
  margin: 0 auto;
  padding: 1rem 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  position: relative;
  z-index: 101;
}

.header-left {
  flex-shrink: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 140px;
  min-height: 2.8rem;
  text-decoration: none;
  color: #1f2937;
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.2s;
}

.logo-link:hover {
  color: #34894d;
}

.logo-img,
.logo-img-flores {
  height: 3rem;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  flex-shrink: 0;
}

.logo-text {
  color: #34894d;
  font-weight: 700;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  justify-content: center;
  flex-wrap: wrap;
}

.nav-link {
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #1f2937;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.3;
  transition: color 0.2s;
  white-space: nowrap;
}

.nav-link:hover {
  color: #34894d;
}

.nav-link.active {
  color: #34894d;
  font-weight: 600;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.cart-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  color: #4b5563;
  text-decoration: none;
  transition: color 0.2s;
}

.cart-link:hover {
  color: #34894d;
}

.cart-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.cart-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #34894d;
  color: white;
  font-size: 0.6875rem;
  font-weight: 700;
  min-width: 1.125rem;
  height: 1.125rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.25rem;
  border: 2px solid white;
}

.btn-fale-conosco {
  background: #34894d;
  color: white;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 0.25rem;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
}

.btn-fale-conosco:hover {
  background: #2d7a42;
  color: white;
  text-decoration: none;
}

/* Hamburger - escondido no desktop */
.btn-menu-mobile {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 3rem;
  height: 3rem;
  padding: 0.5rem;
  background: #34894d;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-menu-mobile:hover {
  background: #2d7a42;
}

.btn-menu-mobile .hamburger {
  display: block;
  width: 100%;
  min-width: 1.25rem;
  height: 3px;
  background-color: #ffffff;
  border-radius: 1px;
  transition: transform 0.2s, opacity 0.2s;
}

.btn-menu-mobile.active .hamburger:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.btn-menu-mobile.active .hamburger:nth-child(2) {
  opacity: 0;
}

.btn-menu-mobile.active .hamburger:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Overlay mobile (estilo footerenav) */
.header-mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

.header-mobile-overlay.ativo {
  opacity: 1;
  pointer-events: all;
}

.header-mobile-nav {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 20rem;
  height: 100vh;
  background: #f3f9f7;
  padding: 5rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 0;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
}

.header-mobile-nav .nav-link {
  padding: 1rem 0;
  border-bottom: 0.1rem solid #56ac89;
  font-size: 1.125rem;
  font-weight: 600;
  color: #34894d;
}

.header-mobile-nav .nav-link:hover {
  color: #2d7a42;
}

.header-mobile-nav .btn-fale-conosco {
  margin-top: 1.5rem;
  text-align: center;
}

/* Responsivo - similar ao footerenav (1100px) */
@media (max-width: 1100px) {
  .header-inner {
    padding: 1.25rem 40px;
  }

  .header-nav {
    display: none;
  }

  .btn-menu-mobile {
    display: flex;
  }

  .header-mobile-overlay {
    display: block;
  }

  .logo-text {
    display: none;
  }

  .logo-img,
  .logo-img-flores {
    height: 2.5rem;
  }
}

@media (max-width: 600px) {
  .header-inner {
    padding: 1rem 1.5rem;
  }

  .header-right .btn-fale-conosco {
    display: none;
  }

  .header-mobile-nav {
    max-width: 100%;
  }
}
</style>
